import Configuration from '../configuration';
import { $httpProvider } from '../providers';

import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';

function getAntenneLTEPerturbation(codeinsee, adresse, datePerturbation, latitude, longitude, rayon) {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.getAntenneLTEPerturbation,
    params: {
      adresse,
      commune: codeinsee,
      datesignalement: datePerturbation,
      rayon: rayon
    }
  }).then(r => mapKeys(r.data, (value, key) => camelCase(key)));
}

function getReamenagement(adresse, nomCommune) {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.getReamenagement,
    params: {
      adresse,
      commune: nomCommune
    }
  }).then(r => mapKeys(r.data, (value, key) => camelCase(key)));
}

export default {
  getAntenneLTEPerturbation, getReamenagement
};



// WEBPACK FOOTER //
// ./src/repositories/antenne.repository.js